import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import "../styles.css";

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact ZeMaxi"
        description="Get in touch with ZeMaxi for business inquiries, collaborations, or streaming tool support. Connect via Twitter, TikTok, or Ko-fi."
        keywords="contact ZeMaxi, streamer contact, business inquiries, collaboration, streaming support"
        url="https://zemaxi.com/contact"
      />
      <Navbar />
      {/* <div id="loader">
        <div className="spinner"></div>
      </div> */}
      <main>
        <section className="contact-section">
          <div className="container">
            <h1>Contact</h1>
            <p>You can reach out via social media or Ko-fi for business inquiries.</p>
            <ul>
              <li><a href="https://x.com/zemaxiirl" target="_blank" rel="noopener noreferrer">X (Twitter)</a></li>
              <li><a href="https://tiktok.com/@zemaxi" target="_blank" rel="noopener noreferrer">TikTok</a></li>
              <li><a href="https://ko-fi.com/zemaxi" target="_blank" rel="noopener noreferrer">Ko-fi</a></li>
            </ul>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
